

































































































































































import Vue, { PropType } from "vue";

import RestClient, { RestError } from "../../RestClient";
import OverlayWindow from "../general/OverlayWindow.vue";
import Loading from "../general/Loading.vue";

import ModulesJson from "../../shared/ModulesJson";
import LocationJson, {
  defaultLocationJson,
  validateLocationJson,
  validateLocationJsonAddNew,
} from "../../shared/LocationJson";

import { UserPermissionRank, UserPermissionRankNames } from "../../shared/UserPermissionRank";
import UserPermission, { defaultUserPermissionJson } from "../../shared/UserPermission";
import { UserPermissionType, UserPermissionTypeNames } from "../../shared/UserPermissionType";
import UserPermissionTypeInfoJson, { UserPermissionTypeInfos } from "../../shared/UserPermissionTypeInfoJson";

import { validateUserJson } from "../../shared/UserJson";
import { ValidationResult, Validation } from "../../shared/Validation";

export default Vue.extend({
  name: "SettingsLocationForm",
  components: {
    OverlayWindow,
    Loading,
  },
  props: {
    restClient: RestClient,
    loginPermission: Number,
    allActiveModules: Array as PropType<ModulesJson[]>,
    mode: String,
    editable: Boolean,
    locationId: Number,
  },
  data() {
    return {
      detailsTitle: "",
      detailsMode: "",
      selectedId: null as number | null,
      details: null as LocationJson | null,
      allLocations: null as LocationJson[] | null,
      hasChanges: false,
      toValidate: {} as any,
      validation: null as ValidationResult<LocationJson> | null,
      submitValidation: false as boolean,
      frontendValidations: {
        title: false,
      },
      titleTimeout: null as any,
      loadingTitleAvailability: false as boolean,
      loadingGeneral: false as boolean,
    };
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      this.details = null;
      this.selectedId = this.locationId;
      this.loadAllLocations();
      this.loadDetails();
    },

    async loadDetails() {
      if (this.selectedId != null) {
        if (this.restClient != null) {
          try {
            this.details = await this.restClient.getLocation(this.selectedId);
          } catch (e) {
            alert(e.message);
          }
        }
      } else {
        this.details = this.getDefaultLocationData();
      }

      this.$nextTick(() => {
        this.hasChanges = false;
      });
    },

    async loadAllLocations() {
      if (this.restClient != null) {
        try {
          this.allLocations = await this.restClient.getLocations();
        } catch (e) {
          alert(e.message);
        }
      }
    },

    getDefaultLocationData() {
      return { ...defaultLocationJson() };
    },

    closeDetails() {
      if (!this.hasChanges) {
        this.$emit("close");
      } else {
        let c = confirm("Sie haben Änderungen vorgenommen. Durch Klicken auf OK gehen diese Änderungen verloren.");
        if (c == true) {
          this.$emit("close");
        } else {
          //do nothing
        }
      }
    },

    inputValidation(key: any, prop: any) {
      if (prop) {
        if (!(key in this.toValidate)) {
          this.toValidate[key] = {};
        }
        this.toValidate[key][prop] = true;
      } else {
        this.toValidate[key] = true;
      }

      if (this.details != null) {
        this.validation = validateLocationJson(this.details);
      }

      this.$forceUpdate();
    },

    removeValidationHint(key: any, prop: any) {
      if (key in this.toValidate) {
        if (prop) {
          delete this.toValidate[key][prop];
        } else {
          delete this.toValidate[key];
        }
      }

      this.$forceUpdate();
    },

    checkFrontendValidations() {
      let check = true;

      let k = this.frontendValidations;
      let i: keyof typeof k;
      for (i in this.frontendValidations) {
        if (this.frontendValidations[i] == true) {
          check = false;
        }
      }

      return check;
    },

    async checkTitleAvailability(timeout: boolean = true) {
      this.loadingTitleAvailability = true;
      clearTimeout(this.titleTimeout);

      let vue = this;

      this.titleTimeout = setTimeout(
        async function () {
          if (vue.allLocations != null && vue.details != null && vue.details.title != "") {
            let exists = vue.allLocations.find((i: LocationJson) => i.title == vue.details?.title);

            if (exists && exists.ID != vue.details.ID) {
              vue.frontendValidations.title = true;
              vue.loadingTitleAvailability = false;
            } else {
              vue.frontendValidations.title = false;
              vue.loadingTitleAvailability = false;
            }
          } else {
            vue.frontendValidations.title = false;
            vue.loadingTitleAvailability = false;
          }
        },
        timeout ? 600 : 0
      );
    },

    async addNewLocation() {
      if (this.details != null) {
        this.loadingGeneral = true;

        this.checkTitleAvailability(false);

        this.submitValidation = true;

        this.validation = validateLocationJsonAddNew(this.details);

        if (this.validation != null && this.validation.isValid == true && this.checkFrontendValidations()) {
          if (this.restClient != null) {
            try {
              this.details = await this.restClient.addLocation(this.details);
              this.hasChanges = false;
              this.loadingGeneral = false;
              this.closeDetails();
              alert("Der Ort wurde erfolgreich hinzugefügt.");
            } catch (e) {
              this.loadingGeneral = false;
              alert(e.message);
            }
          }
        } else {
          this.loadingGeneral = false;
          alert("Der Ort konnte nicht hinzugefügt werden. Bitte überprüfen Sie Ihre Angaben.");
        }
      }
    },

    async saveLocation() {
      if (this.details != null) {
        if (this.hasChanges) {
          this.loadingGeneral = true;

          this.checkTitleAvailability(false);

          this.validation = validateLocationJson(this.details);

          if (this.validation != null && this.validation.isValid == true && this.checkFrontendValidations()) {
            if (this.restClient != null) {
              try {
                this.details = await this.restClient.updateLocation(this.details);
                this.hasChanges = false;
                this.loadingGeneral = false;
                alert("Die Änderungen wurden erfolgreich gespeichert.");
                this.closeDetails();
              } catch (e) {
                this.loadingGeneral = false;
                alert(e.message);
              }
            }
          } else {
            this.loadingGeneral = false;
            alert("Die Änderungen konnten nicht gespeichert werden. Bitte überprüfen Sie Ihre Änderungen.");
          }
        } else {
          alert("Es wurden keine Änderungen vorgenommen.");
          this.closeDetails();
        }
      }
    },

    async deleteLocation() {
      if (this.selectedId != null) {
        let c = confirm("Wollen Sie diesen Ort wirklich unwiderruflich löschen?");
        if (c == true) {
          if (this.restClient != null) {
            try {
              await this.restClient.deleteLocation(this.selectedId);
              this.closeDetails();
              alert("Der Ort wurde gelöscht.");
            } catch (e) {
              alert(e.message);
            }
          }
        } else {
          //do nothing
        }
      }
    },
  },
  watch: {
    details: {
      handler() {
        this.hasChanges = true;
      },
      deep: true,
    },

    locationId: {
      handler() {
        this.init();
      },
    },

    loadingGeneral: {
      handler() {
        this.$emit("loading", this.loadingGeneral || this.loadingTitleAvailability);
      },
    },

    loadingTitleAvailability: {
      handler() {
        this.$emit("loading", this.loadingGeneral || this.loadingTitleAvailability);
      },
    },
  },
  computed: {},
});
